import { validatePriceFluctuationData } from '@nykaa/ui-kit/component/PriceFluctuationNudge/utils';
import { isCurrentTimeInRange } from '@nykaa/ui-kit/component/CountDownTimer/utils';
import {
  pricingNudgeTrackingKeys,
  differentitalPricingVisible,
  priceFluctuationDataAvailable,
  priceFluctuationVisible,
  isLowestPriceEverEligible,
  isLowestPriceEverShown,
  isPriceDroppedShown,
  isPriceDroppedEligible,
  isFirstTimeOnDiscountEligible,
  isFirstTimeOnDiscountShown,
  differentialSaleTimer,
} from 'constants/productPage';
import { getPRData, useIsPDPage } from 'helpers/utils/product';
import { useSelector } from 'react-redux';
import { selectCurrentSku } from 'store/product/selector';
import { PriceFluctuationTrackingKeys } from 'store/product/types';
import { State } from 'store/types';

export const useGetNudgesState = () => {
  const nudgesState = {
    differentitalPricingVisible: false,
    priceFluctuationVisible: false,
    priceFluctuationDataAvailable: false,
    differentialSaleTimer: false,
  };

  const currentSku = useSelector((state: State) => selectCurrentSku(state));
  const isPRV5Enabled = useSelector(
    (state: State) => state.remoteConfig.switches.isPDPriceRevealEnabled
  );
  const isPriceFluctutationEnabled = useSelector(
    (state: State) => state.remoteConfig.switches?.isPriceFluctutationEnabled
  );
  const config = useSelector(
    (state: State) => state.remoteConfig.configs.pdPriceReveal
  );
  const isDifferential = useSelector(
    (state: State) => state.remoteConfig.switches?.differentialPricingEnabled
  );
  const { urgencyTemplate } = currentSku || {};
  const { isActive } = config;
  const finalPrData = getPRData(isDifferential, isPRV5Enabled, currentSku);
  const isPdPage = useIsPDPage();

  if (isActive && finalPrData && (isDifferential || finalPrData?.price)) {
    if (isDifferential && !finalPrData?.showPinkBoxCTA && isPRV5Enabled) {
      if (finalPrData?.startTime && finalPrData?.endTime) {
        const { showSection } =
          isCurrentTimeInRange(finalPrData?.startTime, finalPrData?.endTime) ||
          {};
        if (showSection) {
          nudgesState[differentitalPricingVisible] = true;
        }
      }
      if (finalPrData?.showTimer) {
        nudgesState[differentialSaleTimer] = true;
      }
    } else {
      nudgesState[differentitalPricingVisible] = true;
    }
  }
  if (
    isPdPage &&
    validatePriceFluctuationData(urgencyTemplate) &&
    urgencyTemplate?.text
  ) {
    nudgesState[priceFluctuationDataAvailable] = true;
    if (!nudgesState[differentitalPricingVisible] && isPriceFluctutationEnabled)
      nudgesState[priceFluctuationVisible] = true;
  }
  return nudgesState;
};

export const updateTrackingKeys = (
  nudgeVisible: boolean,
  nudgeAvailable: boolean,
  templateName: string,
  trackingKeys: PriceFluctuationTrackingKeys
) => {
  switch (templateName) {
    case 'lowest_price_ever':
      if (nudgeAvailable) trackingKeys[isLowestPriceEverEligible] = true;
      if (nudgeVisible) trackingKeys[isLowestPriceEverShown] = true;
      break;
    case 'price_dropped':
      if (nudgeAvailable) trackingKeys[isPriceDroppedEligible] = true;
      if (nudgeVisible) trackingKeys[isPriceDroppedShown] = true;
      break;
    case 'first_discount':
      if (nudgeAvailable) trackingKeys[isFirstTimeOnDiscountEligible] = true;
      if (nudgeVisible) trackingKeys[isFirstTimeOnDiscountShown] = true;
      break;
    default:
      break;
  }
  return trackingKeys;
};

export const usePriceFluctutationTrackingState = (
  nudgeVisible: boolean,
  nudgeAvailable: boolean
) => {
  const currentSku = useSelector((state: State) => selectCurrentSku(state));
  const trackingKeys: PriceFluctuationTrackingKeys = {
    ...pricingNudgeTrackingKeys,
  };
  if (!nudgeAvailable) return trackingKeys;

  const { urgencyTemplate } = currentSku || {};
  const { templateName } = urgencyTemplate || {};
  const updatedTrackingKeys = updateTrackingKeys(
    nudgeVisible,
    nudgeAvailable,
    templateName,
    trackingKeys
  );
  return updatedTrackingKeys;
};
